import {
  FormLayout,
  Panel,
  PanelSection,
  PanelHeader,
  PanelTitle,
  PanelDescription,
} from '@customerio/pluma-components/react';
import { withForm, TextField } from '@/components/form';
import { formOpts } from '@/features/ai-business-profile/helpers/form';

export const KeyLinksInfo = withForm({
  ...formOpts,
  props: {
    canEdit: true,
  },
  render: function KeyLinksInfo({ form, canEdit }) {
    return (
      <Panel>
        <PanelHeader>
          <PanelTitle>Key links</PanelTitle>
          <PanelDescription>AI features can reference these links when needed in generating content</PanelDescription>
        </PanelHeader>
        <PanelSection>
          <FormLayout>
            <TextField
              name="privacyPolicyUrl"
              api={form}
              label="Privacy policy"
              placeholder="https://example.com/privacy"
              isDisabled={canEdit === false}
            />
            <TextField
              name="termsOfServiceUrl"
              api={form}
              label="Terms of service"
              placeholder="https://example.com/terms"
              isDisabled={canEdit === false}
            />
            <TextField
              name="pricingUrl"
              api={form}
              label="Pricing"
              placeholder="https://example.com/pricing"
              isDisabled={canEdit === false}
            />
            <TextField
              name="downloadUrl"
              api={form}
              label="Download"
              placeholder="https://example.com/download"
              isDisabled={canEdit === false}
            />
          </FormLayout>
        </PanelSection>
      </Panel>
    );
  },
});
